module.exports = __webpack_public_path__ + "img/Icon-5_purse.51bb2787.svg";